import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { JOURNAL_POSTS } from "@/data/content";
import { FadeUp, SectionHeading } from "./Reveal";

export const Journal = () => (
  <section
    id="journal"
    data-testid="journal-section"
    className="border-y border-jawa-stone bg-jawa-stone/40"
  >
    <div className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
      <FadeUp className="flex flex-wrap items-end justify-between gap-8">
        <SectionHeading overline="The JÀWÀ Journal" title="Stories worth the journey." />
        <Link
          to="/journal"
          data-testid="journal-all-link"
          className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.25em] text-jawa-turquoise transition-colors hover:text-jawa-espresso"
        >
          All Journal stories <ArrowUpRight className="h-4 w-4" />
        </Link>
      </FadeUp>

      <div className="mt-16 grid gap-6 md:grid-cols-3">
        {JOURNAL_POSTS.map((p, i) => (
          <FadeUp key={i} delay={i * 0.08}>
            <Link
              to={`/journal/${p.slug}`}
              data-testid={`journal-card-${i}`}
              className="group relative block h-[480px] cursor-pointer overflow-hidden"
            >
              <img
                src={p.image}
                alt={p.kicker}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-jawa-nearblack/85 via-jawa-nearblack/25 to-transparent" />
              <span className="absolute left-5 top-5 bg-jawa-coral px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.25em] text-white">
                {p.kicker}
              </span>
              <div className="absolute inset-x-0 bottom-0 p-7">
                <h3 className="font-serif text-2xl font-medium italic tracking-tight text-jawa-ivory">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-jawa-ivory/70">{p.text}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-jawa-gold">
                  Read the story <ArrowUpRight className="h-3.5 w-3.5" />
                </span>
              </div>
            </Link>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
